import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line import/no-cycle
import { useFetch } from '../../../services/transports';
import { listSubscriptionTypes } from '../../../api/managementUsers';
import { languages } from '../../../constants';
import { LabeledSelect } from '..';

export const SubscriptionTypeDropdown = ({ label, id, onChange, withAsterisks, disabled, value, multiple }) => {
  const { i18n, t } = useTranslation();

  const [ options, setOptions ] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [ { data }, fetchSubscriptionTypes ] = useFetch(
    listSubscriptionTypes,
    useCallback(response => {
      const container = response?.data?.container;

      return container;
    }, [])
  );

  useEffect(() => {
    fetchSubscriptionTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const mappedOptions = data.map(i => ({
        value: i.id,
        text: i18n.language === languages.EN ? `${i.nameEn}` : `${i.nameAr}`,
        item: i
      }));
      setOptions(mappedOptions);
    } else {
      setOptions([]);
    }
  }, [ data, i18n.language ]);

  const displayValue = useMemo(() => {
    if (value === undefined || value === null) { return value; }
    const foundOption = options.find(opt =>
      opt.value === value
      || opt.value === Number(value)
      || String(opt.value) === String(value));

    return foundOption ? foundOption.value : value;
  }, [ value, options ]);

  return (
    <LabeledSelect
      data-testid={ `${id}-subscription-types` }
      label={ label }
      id={ id }
      mode={ multiple ? 'multiple' : undefined }
      onChange={ onChange }
      showSearch={ true }
      options={ options }
      filterOption={ true }
      EmptyComponent={ t('ERR.noMatched') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear
      value={ displayValue }
      placeholder={ t('fields.choose') }
    />
  );
};

